<template>
  <v-dialog
    v-model="dialog"
    width="600"
  >
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        {{ message }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="secondary"
          text
          @click="_ => onConfirm()"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmActionDialog',

  props: {
    message: {
      type: String,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    value: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    dialog: {
      get () {
        return this.value
      },

      set (value) {
        this.$emit('input', value)
      },
    },
  },

  methods: {
    onConfirm () {
      this.$emit('confirm')
      this.dialog = false
    },
  },
}
</script>
